import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueWechatTitle from 'vue-wechat-title';
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.scss'
    

import './assets/style/reset.css'
import './assets/style/common.scss';


Vue.use(VueWechatTitle)
Vue.use(vueSwiper)

Vue.config.productionTip = false



router.afterEach((to,from,next) => {
  // 自动跳转到顶部
  window.scrollTo(0,0); 
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
